const DEFAULT_STL_BASE = 'https://rww-projects.s3.us-east-1.amazonaws.com'

export function getProgressStlBaseUrl(): string {
  const raw = process.env.REACT_APP_PROGRESS_STL_BASE_URL ?? DEFAULT_STL_BASE
  return raw.replace(/\/+$/, '')
}

export function buildProgressStlUrl(
  stlFileKey: string | null | undefined,
): string | null {
  if (!stlFileKey || !stlFileKey.trim()) {
    return null
  }
  const base = getProgressStlBaseUrl()
  const key = stlFileKey.replace(/^\/+/, '')
  return `${base}/${key}`
}

export function isLocalDemoStlFallback(): boolean {
  return process.env.REACT_APP_PROGRESS_STL_USE_LOCAL_DEMO === '1'
}

/** Use unsigned S3 URLs only when explicitly enabled (bucket must allow public GET). */
export function isPublicStlUrlFallback(): boolean {
  return process.env.REACT_APP_PROGRESS_STL_USE_PUBLIC_STL_FALLBACK === '1'
}

/**
 * Prefer presigned stl_url from the jobs API. Unsigned rww-projects URLs return 403
 * on the private bucket unless REACT_APP_PROGRESS_STL_USE_PUBLIC_STL_FALLBACK=1.
 */
export function resolveProgressStlUrl(item: {
  stl_url?: string | null
  stl_file_key?: string | null
}): string | null {
  if (item.stl_url) {
    return item.stl_url
  }
  if (isPublicStlUrlFallback()) {
    return buildProgressStlUrl(item.stl_file_key)
  }
  return null
}
